import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../../context/CartContext';

export default function CartButton({ size = 'default' }) {
  const { setIsCartOpen, getCartCount } = useCart();
  const cartCount = getCartCount();

  const isSmall = size === 'sm';

  return (
    <button
      onClick={() => setIsCartOpen(true)}
      className={`relative text-white hover:text-orange-500 transition-colors ${isSmall ? 'p-1' : 'p-2'}`}
    >
      <ShoppingCart className={isSmall ? 'w-5 h-5' : 'w-6 h-6'} />
      <AnimatePresence>
        {cartCount > 0 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className={`absolute -top-1 -right-1 bg-gradient-to-r from-orange-500 to-red-600 rounded-full flex items-center justify-center ${isSmall ? 'w-4 h-4' : 'w-5 h-5'}`}
          >
            <span className={`text-white font-bold ${isSmall ? 'text-[10px]' : 'text-xs'}`}>
              {cartCount > 9 ? '9+' : cartCount}
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
